export const LANDING_PAGE_URL = 'https://vizion.space';

export const ROUTE_MAP = {
  map: {
    id: 'map',
    label: 'Bản đồ',
  },
  overview: {
    id: 'front-view',
    label: 'Tổng quan The E-Town',
  },
  'floor-plan': {
    id: 'floor-plan',
    label: 'Mặt bằng tầng',
  },
  masterplan: {
    id: 'masterplan',
    label: 'Sơ đồ tổng thể',
  },
  interior: {
    id: 'apartment',
    label: 'Căn hộ',
  },
  neighborhood: {
    id: 'regional-linkage',
    label: 'Liên kết vùng',
  },
  amenities: {
    id: 'amenities',
    label: 'Tiện ích',
  },
  office: {
    id: 'office-for-lease',
    label: 'Văn phòng mẫu',
  },
  others: {
    id: 'others',
    label: 'Tiện ích khác',
  },
};

export const SCENE_IDS = {
  main_view: '68e768a4fa4f187e528e21c2',
  studio: '68fafb7ae62230d4b4453d49',
  '1bedroom': '68fadb0abeb5aead0ada1c6b',
  '2pn': '68fafb04e62230d4b4453c85',
  '3pn': '68faffe9e62230d4b44540ff',
};
